import { Outlet } from 'react-router-dom';
import { UserNav } from '../components/UserNav';
import { HelpButton } from '../components/HelpButton';
import ClientSidebar from '../components/client/sidebar/ClientSidebar';
import { useAuth } from '../contexts/AuthContext';
import { Sparkles } from 'lucide-react';

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good Morning';
  if (hour < 18) return 'Good Afternoon';
  return 'Good Evening';
};

export default function ClientLayout() {
  const { user, profile } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <ClientSidebar />

      {/* Main content area */}
      <div className="flex flex-1 flex-col lg:pl-72">
        {/* Desktop header - hidden on mobile */}
        <div className="hidden lg:sticky lg:top-0 lg:z-40 lg:flex lg:h-14 lg:shrink-0 lg:items-center lg:justify-between lg:gap-x-4 lg:border-b lg:border-gray-200 lg:bg-white/90 lg:backdrop-blur-md lg:px-6 lg:shadow-sm transition-all duration-300">

          {/* Welcome Message */}
          <div className="flex items-center gap-2 animate-in fade-in slide-in-from-left-4 duration-700">
            <div className="bg-gradient-to-tr from-primary/10 to-blue-500/10 p-1.5 rounded-lg">
              <Sparkles className="h-4 w-4 text-primary animate-pulse" />
            </div>
            <div className="flex flex-col">
              <h2 className="text-sm font-bold text-gray-800 leading-none flex items-center gap-1">
                {getGreeting()}, <span className="bg-gradient-to-r from-primary via-blue-600 to-purple-600 bg-clip-text text-transparent">
                  {(profile?.name ? profile.name.split(' ')[0] : user?.user_metadata?.full_name?.split(' ')[0]) || 'Partner'}
                </span>
              </h2>
              <p className="text-[10px] font-medium text-gray-400 tracking-wide">Ready to lead the market?</p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <UserNav />
          </div>
        </div>

        {/* Main content */}
        <main className="flex-1 overflow-x-hidden">
          <div className="py-2 px-4 sm:px-6 lg:px-8 max-w-full">
            <Outlet />
          </div>
        </main>
      </div>

    </div>
  );
} 